export const adminRedirect: string = '/admin';
export const driverRedirect: string = '/driver';
export const kitchenRedirect: string = '/kitchen';
export const managerRedirect: string = '/manager';
export const userRedirect: string = '/user';
export const printLabelsMainRedirect: string = '/print_labels_main';
export const printLabelsMainSideRedirect: string = '/print_labels_side_main';
export const printLabelsTeaSideRedirect: string = '/print_labels_side_tea';
export const printLabelsTeaRedirect: string = '/print_labels_tea';